import { reducerWithInitialState } from 'typescript-fsa-reducers';
import * as lodash from 'lodash';
import { SupportHistoryListType, SupportHistory, SupportHistorySortState } from '../../type/support-history/support-history.type';
import { SupportHistoryActions } from './support-history.action';
import { SupportHistoryCollection } from '../../collection/support-history/support-history.collection';
import { concatList } from '../root.reducer';

export type SupportHistoryState = {
  supportHistory: SupportHistory | null;
  list: SupportHistoryListType[] | null;
  sort: SupportHistorySortState;
};

const initialState: SupportHistoryState = {
  supportHistory: null,
  list: null,
  sort: SupportHistoryCollection.initialSortState(),
};

export const SupportHistoryReducer = reducerWithInitialState<SupportHistoryState>(initialState)
  .case(SupportHistoryActions.setSupportHistory, (state, payload) => ({
    ...state,
    supportHistory: lodash.cloneDeep(payload),
  }))
  .case(SupportHistoryActions.setList, (state, payload) => ({
    ...state,
    list: lodash.cloneDeep(payload),
  }))
  .case(SupportHistoryActions.setConcatList, (state, payload) => ({
    ...state,
    list: lodash.cloneDeep(concatList(state.list, payload)),
  }))
  .case(SupportHistoryActions.setSort, (state, payload) => ({
    ...state,
    sort: payload ? lodash.cloneDeep({
      ...state.sort,
      ...payload,
    }) : SupportHistoryCollection.initialSortState(),
  }))
  .case(SupportHistoryActions.setInitSort, (state, payload) => ({
    ...state,
    sort: SupportHistoryCollection._initialSortState(payload),
  }))
  .case(SupportHistoryActions.resetState, () => initialState)
  .default((state) => state);
